import axios from "axios";
import { URL_LOGIN_V2, URL_LOGOUT } from "constants/urlApis";
import { endpointError } from "utils/codeErrorsTimeout";

/**
 * Sends a login request to the server with the provided username and password.
 * @param {string} username - The username for login.
 * @param {string} password - The password for login.
 * @returns {Promise<Object>} The response data from the server if the request is successful.
 * @throws {Error} Throws an error if the request fails.
 */
export const loginService = async (username, password) => {
  return await axios
    .post(
      URL_LOGIN_V2,
      { user_name: username.toLowerCase(), password: password },
      {
        endpointError: endpointError.login.loginService,
      }
    )
    .then((response) => {
      if (response) return response.data;
    });
};

/**
 * Sends a logout request to the server with the provided JWT token.
 * @param {string} jwt - The JWT token for authorization.
 * @returns {Promise<Object>} The response from the server.
 */
export const logoutService = async (jwt) => {
  const headers = {
    Authorization: `Bearer ${jwt}`,
  };
  const response = await axios.post(
    URL_LOGOUT,
    {},
    {
      headers,
      endpointError: endpointError.login.loginService,
    }
  );
  return response;
};
